import React from 'react'
import twoiphones from "../assets/twoiphones.png"
import appstore from "../assets/appstore.png"
import playstore from "../assets/playstore.png"
import { FaArrowRight } from 'react-icons/fa'


const EarlyAcees = () => {
    return (
        <>
            <div className='h-full md:w-[1442px] w-full flex items-center justify-between flex-col'>
            <section className='bg-black pb-5 flex  justify-center items-center md:flex-row flex-col'>
                <article className='md:w-[50%] w-full flex px-10 mt-10 flex-col'>
                    <h1 className='md:text-[3rem] text-[2rem]'>Early Access</h1>
                    <p className='text-[#E4E4E4] md:w-[70%] text-xl mt-3'>Be the first one to download</p>
                    <p className='text-[#0052FF] md:w-[50%] text-xl mb-3'>Flappy Base App</p>
                    <form className='flex'>
                        <input type="email" placeholder="Your email address" className='bg-black border-2 h-10 text-center border-gray-800'/>
                        <button className='bg-white text-[#0052FF] flex items-center justify-center font-extrabold text-xl w-10 h-9 ml-2'><FaArrowRight /></button>
                    </form>
                    <div className='flex mt-5'>
                        <img src={playstore} alt='' className='w-[27%]'/>
                        <img src={appstore} alt='' className='w-[27%]'/>
                    </div>
                </article>
                <figure className='md:w-[50%] w-[80%] flex items-center justify-center flex-col mt-5'>
                    <img src={twoiphones} alt="" className='md:scale-75'/>
                </figure>
            </section>
            </div>
        </>
    )
}

export default EarlyAcees
